const urlFromEnv = process.env.REACT_APP_API_URL;

if (!urlFromEnv) {
  throw new Error(
    `cria um arquivo .env na raiz do projeto seguindo o exemplo no arquivo .env.example`
  );
}

export const API_URL = urlFromEnv;
